import { render, staticRenderFns } from "./GetLockPassword.vue?vue&type=template&id=788db16d&scoped=true&"
import script from "./GetLockPassword.vue?vue&type=script&lang=js&"
export * from "./GetLockPassword.vue?vue&type=script&lang=js&"
import style0 from "./GetLockPassword.vue?vue&type=style&index=0&id=788db16d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788db16d",
  null
  
)

export default component.exports